// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".root .sbscr .vacation-months {\n    display: flex;\n    flex-direction: column;\n  }\n  .root .sbscr .vacation-months__ruler {\n    color: var(--secondary-bg-text-color);\n  }\n\n@media (max-width: 730px) {\n  .root .vacation-months__ruler {\n    display: none;\n  }\n}\n", ""]);
// Exports
module.exports = exports;
